import React from "react";
import { BiCaretRight } from "react-icons/bi";
import dashbord from "../../../images/featured/dashboard.webp";
import node from "../../../images/featured/nodejs.webp";
import react_js from "../../../images/featured/react_js.png";
import wordpress from "../../../images/featured/wordpress-2.png__1449x1203_q90_subsampling-2.png";
function ReactWordpressNodejs() {
  return (
    <div className="reactnodewordpress_wrapper">
      <div className="top">
        <h1>Wordpress is well suited for many kinds of web solutions.</h1>
      </div>

      <div className="wordpress_item_row">
        <div className="col">
          <ul>
            <li>
      
              <BiCaretRight /> Business websites
            </li>
            <li>
      
              <BiCaretRight />
              Social Platforms (with membership and profiles)
            </li>
            <li>
      
              <BiCaretRight />
              Ecommerce and Online Shops
            </li>
            <li>
      
              <BiCaretRight /> Marketing Websites
            </li>

            <li>
      
              <BiCaretRight />
              Business Directories
            </li>
          </ul>
        </div>
        <div className="col">
          <ul>
            <li>
      
              <BiCaretRight /> Job Boards
            </li>
            <li>
      
              <BiCaretRight />
              Q&A websites
            </li>
            <li>
      
              <BiCaretRight />
              Portfolio Websites
            </li>
            <li>
      
              <BiCaretRight /> Multi-language Websites
            </li>
            <li>
      
              <BiCaretRight />
              Photography Websites
            </li>
            <li>
      
              <BiCaretRight />
              Knowledge-base / Wiki Websites
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

function WordpressBackground() {
  return (
    <div className="wordpress_background">
      <div className="padding_container">
        <div className="wordpress_features_flex">
          <div className="left">
            <h1>Wordpress themes, plugins and solutions</h1>
            <p>
              Our team is skilled in key technologies to make a wordpress
              project a success:
            </p>
            <div className="col">
              <ul>
                <li>
          
                  <BiCaretRight />
                  Responsive Design
                </li>
                <li>
          
                  <BiCaretRight />
                  HTML/CSS/Javascript
                </li>
                <li>
          
                  <BiCaretRight />
                  PHP and Wordpress
                </li>
                <li>
          
                  <BiCaretRight /> Marketings
                </li>
                <li>
          
                  <BiCaretRight />
                  Security and Hosting
                </li>
              </ul>
            </div>
          </div>
          <div className="right">
            <img src={wordpress} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

function ReactFeatures() {
  return (
    <div className="react_features">
      <div className="padding_container">
        <div className="top-area">
          <h1>Me As a React Expert</h1>
        </div>
        <div className="react_feature_flex">
          <div className="left">
            <div className="col">
              <ul>
                <li>
          
                  <BiCaretRight />
                  Cross-platform web applications with React.js
                </li>
                <li>
          
                  <BiCaretRight />
                  Data-heavy websites or applications.
                </li>
                <li>
          
                  <BiCaretRight />
                  Websites or apps that can be categorized into multiple
                  components.
                </li>
                <li>
          
                  <BiCaretRight />
                  Real-time web applications like chat apps.
                </li>
                <li>
          
                  <BiCaretRight />
                  APIs that are capable of handling multiple I/O requests with
                  the capacity to scale.
                </li>
                <li>
          
                  <BiCaretRight />
                  Building streaming apps and apps that are capable of handling
                  traffic spikes.s
                </li>
              </ul>
            </div>
          </div>
          <div className="right">
            <img src={react_js} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

function NodejsFeature() {
  return (
    <div className="nodejsFeatures">
      <div className="padding_container">
        <div className="top-area">
          <h1>
            Start Building Your Projects with Node.js - I am always With your
            best choice.
          </h1>

          <p>
            It's never too late to start using Node.js! As one of the world's
            most widely used programming language and packed with great security
            features, Node.js is by far the ultimate go-to choice for any type of
            business.
            <br /> <br />
            With great dedication in delivering and ensuring the best service
            and quality, My Node.js Team has taken a step even further into
            enhancing and producing the highest standards of security. Projects
            created by me go through intensive PEN tests and are graded
            e-banking grade secure, similar to those used by multi-billion
            dollar financial institutions.
            <br /> <br />
            So, sit back and allow our team of dedicated and ambitious experts,
            with over 10 years of experience, build your dream project
          </p>
        </div>

        <div className="nodejs_flex_items">
          <div className="left">
            <img src={node} alt="" />
          </div>
          <div className="right">
            <h1>Web Development with <br /> <span className="purple">Nodejs</span> </h1>
            <p>
            Web projects can be rapidly built, be reassuringly secure and be cloud-friendly many thanks to Node's wide variety of web development frameworks such as Django, Flask, Pyramid, Falcon, etc. They come equipped with admin panels and are extendable into large ecosystems and more.
<br /> <br />
Node's web frameworks are quality proven and are used by leading digital companies throughout the world. Among them are Nasa, National Geographic, Bitbucket, Pinterest, Spotify, Netflix, and Dropbox.I build amazing Frontend interfaces that are responsive, fast and well integrated with nodejs services.
            </p>
          </div>
        </div>



      </div>
    </div>
  );
}


function NodeJsItem(){
  return(
   <div className="nodejs_item_top">
    <div className="padding_container">
    <div className="top-area">
<h1>Built-in Admin Panel </h1>
<p>Unlike many web frameworks, Nodejs comes with a higly customizable and yet complete admin panel. There is no additional cost and it saves significant development time (and budget) for you. I am a Node.js Developer with experienced in customizing Nodejs admin panel.
  <br />
  <br />
  For every feature, there is a reusable or extendable base that accelerates the development. my team contributes to and works with the Python/Django Ecosystem.
</p>
    </div>


    <div className="react_feature_flex">
    <div className="left">
      <div className="col">
        <ul>
          <li>
    
            <BiCaretRight />
            For APIs there Nodejs REST Framework.
          </li>
          <li>
    
            <BiCaretRight />
            Accessible and user-friendly
          </li>
          <li>
    
            <BiCaretRight />
            Fast, dynamic and consistent.
          </li>
          <li>
    
            <BiCaretRight />
            Real-time web applications like chat apps.
          </li>
          <li>
    
            <BiCaretRight />
            APIs that are capable of handling multiple I/O requests with
            the capacity to scale.
          </li>
          <li>
    
            <BiCaretRight />
            Building streaming apps and apps that are capable of handling
            traffic spikes.s
          </li>
        </ul>
      </div>
    </div>
    <div className="right">
      <img src={dashbord} alt="" />
    </div>
  </div>
  </div>


   </div>
  )
}
export {
  ReactWordpressNodejs,
  WordpressBackground,
  ReactFeatures,
  NodejsFeature,
  NodeJsItem
};
